import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { publicRoutes } from "Router/Routes";
import Loader from "Components/Shared/Loader";
import { Box, Container } from "@mui/material";
import variables from "Styles/variables.scss";
import { useTheme } from "@mui/material/styles";

import WrapHeader from "./wrapHeader";

// import { useUserContext } from "Hooks/UserContext";

/**
 * Body of loggedIn User
 * @returns Body of the application
 */
const Body = () => {
  const theme = useTheme();

  // const { userDetails } = useUserContext();
  // const CurrentUserRole = userDetails ? userDetails.role : "";

  return (
    <Box
      id="loginpage"
      px={{ sm: 2, xs: 0 }}
      py={5}
      bgcolor={theme.palette.mode === "dark" ? variables.darkBg : variables.colorWhite}>
      <Container className="App" sx={{ padding: "0" }} maxWidth="lg">
        <Suspense fallback={<Loader />}>
          <Routes>
            {publicRoutes.map(({ path, ComponentIn, header = false }, key) => {
              return (
                <Route
                  key={key}
                  path={path}
                  caseSensitive
                  match="exact"
                  element={
                    header ? (
                      <WrapHeader>
                        <ComponentIn />
                      </WrapHeader>
                    ) : (
                      <ComponentIn />
                    )
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Container>
    </Box>
  );
};

export default Body;
